// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#searchResult {
	background-color: #ffffff;
	border: 1px solid #aaaaaa;
	/* border-radius: 0px 0px 5px 5px; */
	box-shadow: .1em .25em 1.5em rgba(0, 0, 0, .8);
	display: none;
	max-height: 60vh;
	overflow: auto;
	top: 4.2em;
	transition: all .4s;
	z-index: 0;
}

#searchResult.show {
	display: block;
}
`, "",{"version":3,"sources":["webpack://./src/components/contentFinder/style.css"],"names":[],"mappings":"AAAA;CACC,yBAAyB;CACzB,yBAAyB;CACzB,oCAAoC;CACpC,8CAA8C;CAC9C,aAAa;CACb,gBAAgB;CAChB,cAAc;CACd,UAAU;CACV,mBAAmB;CACnB,UAAU;AACX;;AAEA;CACC,cAAc;AACf","sourcesContent":["#searchResult {\r\n\tbackground-color: #ffffff;\r\n\tborder: 1px solid #aaaaaa;\r\n\t/* border-radius: 0px 0px 5px 5px; */\r\n\tbox-shadow: .1em .25em 1.5em rgba(0, 0, 0, .8);\r\n\tdisplay: none;\r\n\tmax-height: 60vh;\r\n\toverflow: auto;\r\n\ttop: 4.2em;\r\n\ttransition: all .4s;\r\n\tz-index: 0;\r\n}\r\n\r\n#searchResult.show {\r\n\tdisplay: block;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
